export default __webpack_public_path__ + "media/images/fp_header-a29afa3a079687167881bbb4d72285a9.png";